import { render, staticRenderFns } from "./ticket.vue?vue&type=template&id=17d369b6&"
import script from "./ticket.vue?vue&type=script&lang=ts&"
export * from "./ticket.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ticket.vue"
export default component.exports